import { makeStyles } from '@material-ui/core/styles';

const styles = (theme) => ({
  container: {
    backgroundColor: theme.colors.form__background_primary,
    maxWidth: 580
  },
  title: {
    paddingBottom: theme.spacing(6)
  },
  text: {
    color: theme.colors.green_15,
    fontSize: 16,
    fontWeight: 400,
    lineHeight: '24px',
    marginTop: 0,
    paddingBottom: theme.spacing(4)
  },
  icon: {
    width: 25,
    height: 25,
    marginRight: theme.spacing(1)
  },
  loadingBar: {
    width: '100%',
    position: 'absolute',
    bottom: 0,
    left: 0
  },
  calloutText: {
    marginLeft: theme.spacing(2),
    display: 'inline'
  },
  inlineLink: {
    cursor: 'pointer',
    color: theme.colorPalette.orange_10,
    textDecoration: 'underline'
  },
  divider: {
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(4)
  },
  actionText: {
    paddingBottom: theme.spacing(4)
  },
  backIcon: {
    width: 25,
    height: 25,
    transform: 'rotate(180deg)'
  },
  backButton: {
    width: '40%'
  },
  notificationContainer: {
    paddingTop: theme.spacing(4)
  }
});

export default makeStyles(styles);
